import {
  hapticFeedbackImpactOccurred,
  hapticFeedbackNotificationOccurred,
  hapticFeedbackSelectionChanged,
} from '@telegram-apps/sdk-react';

function safeCall(fn: () => void) {
  try {
    fn();
  } catch {
    // Not in Telegram or haptics not supported
  }
}

export const haptics = {
  impact: (style: 'light' | 'medium' | 'heavy' = 'medium') =>
    safeCall(() => hapticFeedbackImpactOccurred(style)),
  success: () => safeCall(() => hapticFeedbackNotificationOccurred('success')),
  error: () => safeCall(() => hapticFeedbackNotificationOccurred('error')),
  warning: () => safeCall(() => hapticFeedbackNotificationOccurred('warning')),
  selection: () => safeCall(() => hapticFeedbackSelectionChanged()),
};
